import React, { forwardRef, useContext, useImperativeHandle, useRef } from 'react';
import type { AppTopbarRef } from '../types';
import AppBreadcrumb from './AppBreadCrumb';
import { LayoutContext } from './context/layoutcontext';
import { useAppSelector } from 'app/config/store';
import { Avatar } from 'primereact/avatar';
import './appTopbar.css';
import { AUTHORITIES } from 'app/config/constants';

const AppTopbar = forwardRef<AppTopbarRef>((props, ref) => {
  const { onMenuToggle, showProfileSidebar, showConfigSidebar } = useContext(LayoutContext);
  const menubuttonRef = useRef(null);

  const onConfigButtonClick = () => {
    showConfigSidebar();
  };

  useImperativeHandle(ref, () => ({
    menubutton: menubuttonRef.current,
  }));

  const initials = name =>
    name
      ? name
          .split(' ')
          .map(w => w[0].toUpperCase())
          .slice(0, 2)
          .join('')
      : '';

  const mapRole = role => {
    if (role) {
      if (role === AUTHORITIES.ADMIN) {
        return 'Admin';
      } else if (role === AUTHORITIES.AGENT) {
        return 'Poradca';
      } else if (role === AUTHORITIES.ASSISTANT) {
        return 'Asistent';
      } else if (role === AUTHORITIES.SUPER_ADMIN) {
        return 'Superadmin';
      }
    }

    return role;
  };

  const getName = account => {
    if (account) {
      if (account.firstName) {
        if (account.lastName) {
          return account.firstName + ' ' + account.lastName;
        }

        return account.firstName;
      } else if (account.lastName) {
        return account.lastName;
      }

      return account.companyName;
    }
  };

  const account = useAppSelector(state => state.authentication.account);
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);

  const name = isAuthenticated ? getName(account) : '';
  const role = isAuthenticated ? account.authorities?.[0] : null;
  const company = isAuthenticated ? account?.companyName : null;

  return (
    <div className="layout-topbar">
      <div className="topbar-start">
        <button ref={menubuttonRef} type="button" className="topbar-menubutton p-link p-trigger" onClick={onMenuToggle}>
          <i className="pi pi-bars"></i>
        </button>

        <AppBreadcrumb className="topbar-breadcrumb"></AppBreadcrumb>
      </div>

      <div className="topbar-end">
        <ul className="topbar-menu">
          {/*<li className="topbar-search">*/}
          {/*  <span className="p-input-icon-left">*/}
          {/*    <i className="pi pi-search"></i>*/}
          {/*    <InputText type="text" placeholder="Search" className="w-12rem sm:w-full" />*/}
          {/*  </span>*/}
          {/*</li>*/}
          {/*<li className="ml-3">*/}
          {/*  <Button*/}
          {/*    type="button"*/}
          {/*    icon="pi pi-cog"*/}
          {/*    text*/}
          {/*    rounded*/}
          {/*    severity="secondary"*/}
          {/*    className="flex-shrink-0"*/}
          {/*    onClick={onConfigButtonClick}*/}
          {/*  ></Button>*/}
          {/*</li>*/}
          <li className="topbar-profile">
            <div className="flex clickable" style={{ alignItems: 'center' }} onClick={showProfileSidebar}>
              <Avatar size="large" style={{ backgroundColor: 'var(--primary-color)', color: '#ffffff' }} className="mr-3">
                {initials(name)}
              </Avatar>
              <div>
                <div>
                  <b>{name}</b>
                </div>
                {company && (
                  <div style={{ justifySelf: 'center', fontSize: '12px' }}>
                    <i>{company}</i>
                  </div>
                )}
                <div style={{ justifySelf: 'center', fontSize: '12px' }}>{mapRole(role)}</div>
              </div>
            </div>
            {/*<button type="button" className="p-link" onClick={showProfileSidebar}>*/}
            {/*  <img src="../public/layout/images/avatar/avatar.png" alt="Profile" />*/}
            {/*  asdf*/}
            {/*</button>*/}
          </li>
        </ul>
      </div>
    </div>
  );
});

AppTopbar.displayName = 'AppTopbar';

export default AppTopbar;
